/* eslint-disable @typescript-eslint/no-explicit-any */
import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client'
import { useFiltersContext } from '@mercadoni/sinister/dist/cjs/filters/context'

import { IS_PRODUCTION } from '@/utils/constants'
import { PAGE_TYPE } from '../../utils/constants'

const BannersLogic = ({ className, Wrapper }: any) => {
  const { enabledAds, adsBanners = {} } = UseClientModelContext()
  const { filters } = useFiltersContext()
  const extraTargeting = { env: IS_PRODUCTION ? 'production' : 'staging' }

  return (
    <Wrapper
      className={className}
      searchTerm={filters.searchTerm}
      pageType={PAGE_TYPE}
      enabledAds={enabledAds}
      adsBanner={adsBanners?.[PAGE_TYPE]}
      extraTargeting={extraTargeting}
    />
  )
}

export default BannersLogic
